/* tslint:disable */
/* eslint-disable */
/**
 * Tanagra Service API
 * github.com/DataBiosphere/tanagra
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Filter } from './Filter';
import {
    FilterFromJSON,
    FilterFromJSONTyped,
    FilterToJSON,
} from './Filter';

/**
 * 
 * @export
 * @interface PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue
 */
export interface PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue {
    /**
     * 
     * @type {Array<Filter>}
     * @memberof PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue
     */
    subfilters?: Array<Filter>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue
     */
    groupByCountAttributes?: Array<string>;
}

/**
 * Check if a given object implements the PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue interface.
 */
export function instanceOfPrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValueFromJSON(json: any): PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue {
    return PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValueFromJSONTyped(json, false);
}

export function PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subfilters': !exists(json, 'subfilters') ? undefined : ((json['subfilters'] as Array<any>).map(FilterFromJSON)),
        'groupByCountAttributes': !exists(json, 'group_by_count_attributes') ? undefined : json['group_by_count_attributes'],
    };
}

export function PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValueToJSON(value?: PrimaryWithCriteriaFilterOccurrenceSubfiltersAndGroupByAttributesValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subfilters': value.subfilters === undefined ? undefined : ((value.subfilters as Array<any>).map(FilterToJSON)),
        'group_by_count_attributes': value.groupByCountAttributes,
    };
}

